import {CHANGE_CURRENCY, CHANGE_CUSTOMER_RISK_LEVELS, CHANGE_LANG, CHANGE_TX_RISK_LEVELS, DEFAULT_COMMON_STATE} from "../constants";

function CommonReducer(state = DEFAULT_COMMON_STATE, action) {

    let type = action.type

    switch (type) {

        case CHANGE_CURRENCY:
            return {
                ...state,
                currency: action.payload
            }

        case CHANGE_LANG:
            return {
                ...state,
                lang: action.payload
            }

        case CHANGE_TX_RISK_LEVELS:
            return {
                ...state,
                txRiskLevels: action.payload
            }

        case CHANGE_CUSTOMER_RISK_LEVELS:
            return {
                ...state,
                customerRiskLevels: action.payload
            }

        default:
            return state
    }
}

export default CommonReducer